import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
 
  FaHeart,
  FaShareAlt,
  FaMapMarkerAlt,
  FaStar,

  FaSwimmingPool,
  FaWifi
} from "react-icons/fa";
import "./PropertyCard.css";

export default function PropertyCard({ data, viewMode = "grid" }) {  // viewMode prop add किया
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  if (!data) return null;

  // Calculate price per sqft if available - FIXED FUNCTION
  const parseIndianPrice = (priceStr) => {
    if (!priceStr) return 0;

    const cleanStr = priceStr.replace(/[₹,]/g, '').trim();

    if (cleanStr.toLowerCase().includes('crore')) {
      return parseFloat(cleanStr) * 10000000;
    }
    if (cleanStr.toLowerCase().includes('lakh')) {
      return parseFloat(cleanStr) * 100000;
    }
    if (cleanStr.includes('/')) {
      return parseFloat(cleanStr.split('/')[0]);
    }

    return parseFloat(cleanStr) || 0;
  };

  const pricePerSqft = data.area ?
    `₹ ${Math.round(parseIndianPrice(data.price) /
      parseFloat(data.area.replace(/[^0-9.]/g, ''))).toLocaleString('en-IN')}/sqft` :
    null;

  // Property type colors
  const typeColors = {
    "For Sale": "#10b981",
    "For Rent": "#3b82f6",
    "Featured": "#f59e0b",
    "Sold": "#ef4444",
    "Premium": "#8b5cf6"
  };

  // Handle favorite toggle
  const handleFavorite = (e) => {
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };

  // Handle share
  const handleShare = (e) => {
    e.stopPropagation();
    if (navigator.share) {
      navigator.share({
        title: data.title,
        text: `Check out this property: ${data.title} - ${data.location}`,
        url: window.location.href,
      });
    }
  };

  // Quick view or navigate to details
  const handleCardClick = () => {
    navigate(`/property/${data.id}`);
  };

  // FIXED: Check if amenities exist before using slice
  const amenitiesToShow = data.amenities ? data.amenities.slice(0, 3) : [];

  return (
    <div
      className={`property-card ${data.isFeatured ? 'featured' : ''} ${viewMode === 'list' ? 'list-layout' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleCardClick()}
      aria-label={`View details for ${data.title} in ${data.location}`}
    >
      {/* Image Container with Overlays */}
      <div className="image-container">
        <img
          src={data.image}
          alt={data.title}
          className="property-image"
          loading="lazy"
          onError={(e) => {
            e.target.src = "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80";
          }}
        />

        {/* Badges */}
        <div className="badges-container">
          <span
            className="type-badge"
            style={{ backgroundColor: typeColors[data.type] || '#3b82f6' }}
          >
            {data.type}
          </span>

          {data.isFeatured && (
            <span className="featured-badge">
              <FaStar /> Featured
            </span>
          )}
        </div>

        {/* Quick Actions Overlay */}
        <div className={`quick-actions ${isHovered ? 'visible' : ''}`}>
          <button
            className={`action-btn favorite-btn ${isFavorite ? 'active' : ''}`}
            onClick={handleFavorite}
            aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
            aria-pressed={isFavorite}
            onKeyDown={(e) => e.key === 'Enter' && handleFavorite(e)}
          >
            <FaHeart />
          </button>
          <button
            className="action-btn share-btn"
            onClick={handleShare}
            aria-label="Share property"
            onKeyDown={(e) => e.key === 'Enter' && handleShare(e)}
          >
            <FaShareAlt />
          </button>
        </div>

        {/* Image Counter for multiple images */}
        {data.imageCount > 1 && (
          <div className="image-counter">
            <span>+{data.imageCount - 1}</span>
          </div>
        )}
      </div>

      {/* Card Content */}
      <div className="card-content">
        {/* Title and Location */}
        <h4 className="property-title">{data.title}</h4>
        <div className="location-section">
          <FaMapMarkerAlt className="location-icon" />
          <span className="property-location">{data.location}</span>
        </div>

        {/* Amenities Preview */}
        {amenitiesToShow.length > 0 && (
          <div className="amenities-preview">
            {amenitiesToShow.map((amenity, index) => (
              <span key={index} className="amenity-tag">
                {amenity === "Swimming Pool" && <FaSwimmingPool />}
                {amenity === "WiFi" && <FaWifi />}
                {amenity}
              </span>
            ))}
            {data.amenities && data.amenities.length > 4 && (
              <span className="more-amenities">+{data.amenities.length - 4} more</span>
            )}
          </div>
        )}

        {/* Property Meta - View Count & Type */}
        <div className="property-meta">
          {/* {data.viewCount !== undefined && (
            <span className="view-count">
              👁️ {data.viewCount.toLocaleString()} views
            </span>
          )} */}

          {data.propertyType && (
            <span className={`property-type-badge type-${data.propertyType}`}>
              {data.propertyType === 'domestic' ? 'Domestic' :
                data.propertyType === 'industrial' ? 'Industrial' :
                  data.propertyType === 'residential' ? 'Residential' : 'Land'}
            </span>
          )}


          {/* Property Stats - Only Listed Date */}
          <div className="property-stats">
            {data.listedDate && (
              <span className="listed-date">
                Listed: {new Date(data.listedDate).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'short'
                })}
              </span>
            )}
          </div>

        </div>

        {/* Property Stats - Only Listed Date */}
        {/* <div className="property-stats">
          {data.listedDate && (
            <span className="listed-date">
              Listed: {new Date(data.listedDate).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short'
              })}
            </span>
          )}
        </div> */}

        {/* Action Buttons */}
        <div className="action-buttons">
          <button
            className="view-details-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCardClick();
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleCardClick()}
          >
            View Details
          </button>


        
          <button
            className="contact-btn"
            onClick={() => window.location.href = 'tel:8487916787'}

          >
            Contact Agent
          </button>






          {/* <button
            className="contact-btn"
            onClick={(e) => {
              e.stopPropagation();
              console.log("Contact agent for:", data.id);
            }}
            onKeyDown={(e) => e.key === 'Enter' && console.log("Contact agent for:", data.id)}
          >
            Contact Agent
          </button> */}
        </div>
      </div>
    </div>
  );
}